import { ApplicationCustomField, ApplicationDefaultCustomFields } from '@schooly/api';

import { CreateCustomField } from './CreateCustomField.type';
export const getCustomFieldsToShow = <T extends ApplicationCustomField | CreateCustomField>(
  fields: T[],
): T[] => {
  return fields.filter(
    (field) =>
      !!field.value ||
      Object.values(ApplicationDefaultCustomFields).includes(
        field.label as ApplicationDefaultCustomFields,
      ),
  );
};

export const hasListChanged = (list1: string[], list2: string[]): boolean => {
  if (list1.length !== list2.length) return true;

  const set1 = new Set(list1);
  const set2 = new Set(list2);

  if (set1.size !== set2.size) return true;

  return !Array.from(set1).every((id) => set2.has(id));
};
